module.exports = __webpack_public_path__ + "img/eagleEye2_2.51fdad64.png";